// components/shared/LoadingScreen.jsx
const LoadingScreen = () => (
  <>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#0f172a',
    }}>
      <div style={{
        width: 36,
        height: 36,
        border: '3px solid rgba(34,211,238,0.15)',
        borderTopColor: '#22d3ee',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
    </div>
  </>
);

export default LoadingScreen;